import { render, staticRenderFns } from "./QuotationInsuredForm.vue?vue&type=template&id=cfe43cbc"
import script from "./QuotationInsuredForm.vue?vue&type=script&lang=js"
export * from "./QuotationInsuredForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports